import React, { Component } from 'react';
import DataTable from "react-data-table-component";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Pie } from 'react-chartjs-2';
import { tokenVerification } from './Utils';

class MedicationResults extends Component {
    constructor() {
        super();
        this.state = {
            dataStartedProcessing: false,
            showLoader: false,
            editedName: "",
            editedDescription: "",
            editedDheeProjectId: "",
            editedRuntimeUrl: "",
            editedInstanceId: "",
            disabled: false,
            editedId: "-1",
            pageNum: null,
            paginationValue: 10,
            hidden: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            procedures: [],
            searchTerm: "",
            selectedTreatmentId: "",
            searchIcon: true,
            isLoading: true,
            noMatchingData: false,
            data: [],
            medicationGraphData: [],

        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }
    componentDidMount() {
        var thisController = this;
        thisController.fetchEnrolledAdmissions();
        thisController.fetchMedicationResults();
        thisController.fetchMedicationGraphData();
        if (thisController.props.location.state != undefined) {
            thisController.setState({ pageNum: thisController.props.location.state.pageNum });
        }

    }

    goBackFromSubTab = () => {
        var pageNum = this.props.location.state.pageNum;
        this.props.history.push({
            pathname: "/projectmgmt/reports/medication-adherence",
            state: {
                goBackToFaq: true,
                pageNum: pageNum,
            }
        });
    }

    fetchEnrolledAdmissions = () => {
        var thisController = this;
        var serviceLineId = thisController.props.location.state.serviceLineId;
        $.ajax({
            url: "/my-jeeva-api/get-patient-admissions",
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                patientEmailId: localStorage.getItem("patientEmailId")
            },
            success: function (res) {
                if (res.success === true) {
                    var data = res.result;
                    if (data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            if (serviceLineId == res.result[i].serviceLineId) {
                                thisController.state.procedures.push({
                                    name: res.result[i].procedureName,
                                    value: res.result[i].procedureId,
                                });
                            }
                        }
                        thisController.state.procedures.unshift({ value: "22222222-2222-2222-2222-222222222222", name: "All" });
                        thisController.state.procedures.push({ value: "11111111-1111-1111-1111-111111111111", name: "General Wellness" });
                        thisController.setState(thisController.state);
                        console.log("procedures are : " + thisController.state.procedures);
                    }

                }
            },
        });
    }

    fetchMedicationResults = () => {
        var thisController = this;
        var patientId = thisController.props.location.state.patientId;
        var treatmentId = thisController.state.selectedTreatmentId;
        if (treatmentId == null || treatmentId == undefined || treatmentId == "") {
            treatmentId = "22222222-2222-2222-2222-222222222222";
        }
        $.ajax({
            url: "/my-jeeva-api/get-med-results",
            method: 'GET',
            data: {
                patientId: patientId,
                treatmentId: treatmentId
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    var messages = res.result;
                    thisController.state.disabled = false;
                    thisController.state.showLoader = true;
                    thisController.state.isLoading = false;
                    thisController.state.noMatchingData = false;
                    thisController.state.data = messages;
                    thisController.setState(thisController.state);
                } else {
                    // thisController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        });
    }
    fetchMedicationGraphData() {
        var thisController = this;
        var patientId = thisController.props.location.state.patientId;
        var treatmentId = thisController.state.selectedTreatmentId;
        if (treatmentId == null || treatmentId == undefined || treatmentId == "") {
            treatmentId = "22222222-2222-2222-2222-222222222222";
        }
        $.ajax({
            url: "/my-jeeva-api/fetch-all-medication-adherence",
            method: "GET",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                patientId: patientId,
                treatmentId: treatmentId
            },
            success: function (res) {
                if (res.success === true) {
                    thisController.state.medicationGraphData = res.result;
                    thisController.setState(thisController.state);
                }
            },
            error: function (error) {
                console.error("Error fetching medication data:", error);
            }
        });
    }
    getPieData = (medication) => ({
        labels: ['Taken', 'Not Taken'],
        datasets: [
            {
                data: [medication.percentageTaken, medication.percentageNotTaken],
                backgroundColor: ['lightgreen', 'red'],
                hoverBackgroundColor: ['#36A2EB', '#FF6384']
            }
        ]
    });

    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>There are no medication history present. </p>
        </div>
    );

    onProcedureChange = (e) => {
        this.state.data = [];
        this.state.medicationGraphData = [];
        this.state.isLoading = true;
        this.state.selectedTreatmentId = e.target.value;
        this.setState(this.state);
        this.fetchMedicationResults();
        this.fetchMedicationGraphData();
    }

    caseInsensitiveSort = (field) => (rowA, rowB) => {
        var a;
        var b;
        if (rowA[field] != null && rowB[field] != null) {
            if (field === "createdDate") {
                var formattedDateA = new Date(rowA.createdDate[0], rowA.createdDate[1] - 1, rowA.createdDate[2]).toLocaleDateString('en-US')
                var formattedDateB = new Date(rowB.createdDate[0], rowB.createdDate[1] - 1, rowB.createdDate[2]).toLocaleDateString('en-US')
                a = formattedDateA
                b = formattedDateB
            } else {
                a = rowA[field].toLowerCase();
                b = rowB[field].toLowerCase();
            }
        }

        if (a > b) {
            return 1;
        }

        if (b > a) {
            return -1;
        }

        return 0;
    };

    handleSearch = (event) => {


        var thisController = this;

        var patientId = thisController.props.location.state.patientId;
        var treatmentId = thisController.state.selectedTreatmentId;
        if (treatmentId == null || treatmentId == undefined || treatmentId == "") {
            treatmentId = "22222222-2222-2222-2222-222222222222";
        }
        var searchTerm = event.target.value;
        thisController.state.isLoading = true;
        thisController.state.data = [];
        if (searchTerm == undefined || searchTerm === "" || searchTerm === null) {
            thisController.state.searchTerm = "";
            thisController.state.searchIcon = true;
            // thisController.state.data = [];
            thisController.setState(thisController.state);
            thisController.fetchMedicationResults();
        } else {
            thisController.state.searchTerm = searchTerm;
            thisController.state.searchIcon = false;
            thisController.setState(thisController.state);
        }
        $.ajax({
            url: "/my-jeeva-api/search-med-results",
            method: "GET",
            data: {
                patientId: patientId,
                treatmentId: treatmentId,
                searchTerm: searchTerm,
            },

            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    if (res.result.length > 0) {
                        thisController.state.data = [];
                        thisController.setState(thisController.state);
                        thisController.state.data = res.result;
                        thisController.state.isLoading = false;
                        thisController.state.noMatchingData = false;
                        thisController.setState(thisController.state);
                    } else {
                        thisController.state.noMatchingData = true;
                        thisController.state.isLoading = false;
                        thisController.setState(thisController.state);
                    }
                }
            },
            error: function (xhr) {
            },
        });
    };

    clearSearchData = () => {
        var thisController = this;
        thisController.setState({ searchTerm: "" }, () => {
            thisController.fetchEnrolledAdmissions();
            thisController.fetchMedicationResults();
            thisController.fetchMedicationGraphData();
        });
    }

    render() {

        const columns = [
            {
                name: <b style={{ fontSize: "16px" }}>Date</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('createdDate'),
                selector: (row) => {

                    return (<div name="date">
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                            }}

                            id={"date" + row.id}
                            contentEditable={
                                !(row.id == "" ? false : row.id != this.state.editedId)
                                    ? "plaintext-only"
                                    : false
                            }
                        >
                            {/* {row.createdDate} */}
                            {row.createdDate && row.createdDate.length > 0 ?
                                new Date(row.createdDate[0], row.createdDate[1] - 1, row.createdDate[2]).toLocaleDateString('en-US') :
                                ''
                            }
                        </div>
                    </div>
                    )
                },
            },
            {
                name: <b style={{ fontSize: "16px" }}>Day</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('daysOfWeek'),
                selector: (row) => (
                    <div>
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                            }}
                            id={"daysOfWeek" + row.id}
                            name={"daysOfWeek" + row.id}
                        >
                            {row.daysOfWeek}
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Medication Name</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('medicationName'),
                selector: (row) => (
                    <div>
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                            }}

                            id={"medicationName" + row.id}
                            name={"medicationName" + row.id}
                        >
                            {row.medicationName}
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Medication Unit</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('unitName'),
                selector: (row) => (
                    <div>
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                            }}
                            id={"unit" + row.id}
                            name={"unit" + row.id}
                        >
                            {row.unitName}
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Time</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('timeOfDay'),
                selector: (row) => (
                    <div>
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                            }}
                            id={"timeOfDay" + row.id}
                            name={"timeOfDay" + row.id}
                        >
                            {row.timeOfDay ? row.timeOfDay.split(':').slice(0, 2).join(':') + ' ' + row.timeOfDay.slice(-2) : ""}
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Status</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('medicationStatus'),
                selector: (row) => (
                    <div>
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                            }}
                            id={"medicationStatus" + row.id}
                            name={"medicationStatus" + row.id}
                        >
                            {row.medicationStatus ? row.medicationStatus.charAt(0).toUpperCase() + row.medicationStatus.slice(1).toLowerCase().replace(/_/g, ' ') : ""}
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Reason Skipped</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('reasonsToSkip'),
                selector: (row) => (
                    <div>
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                            }}
                            id={"reasonsToSkip" + row.id}
                            name={"reasonsToSkip" + row.id}
                        >
                            {row.reasonsToSkip ? row.reasonsToSkip : "-"}
                        </div>
                    </div>
                ),
            },


        ];
        return (
            <div style={{ background: "#F9F9FB", marginRight: "1%" }}>
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                {/* for reactTable */}
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />


                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                {/* Font Awesome Icons */}
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                {/* IonIcons */}
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                {/* Select2 */}
                <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <link rel="stylesheet" href="./assets/css/styles.css" />
                <link rel="stylesheet" href="assets/css/DashBoardGraph.css" />
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row">
                        </div>
                        <div className="row">
                            <div className="col-sm-4" style={{ marginTop: '16px' }}  >
                                <img src="assets/images/arrow.svg"
                                    style={{ paddingRight: "30%", cursor: 'pointer' }}
                                    onClick={this.goBackFromSubTab}
                                />
                            </div>
                            <div className="col-sm-4">
                                <h6 className="nav-item" style={{ color: '#282a65', textAlign: "left", marginTop: '16px' }}>
                                    Medication Results of {this.props.location.state.patientName}</h6>
                            </div>
                            {/* Add button */}
                            <div className="col-sm-4" Align='right'>
                                <label
                                    style={{
                                        marginLeft: "-40vh",
                                        // display:
                                        //     window.SCOPE_VALUE.CURRENT >
                                        //         window.SCOPE_VALUE.SERVICELINE_ADMIN
                                        //         ? "inline"
                                        //         : "none",
                                    }}
                                >
                                    Treatments
                                </label>
                                <select
                                    value={this.state.selectedTreatmentId}
                                    onChange={(e) => this.onProcedureChange(e)}
                                    placeholder="Select treatment"
                                    style={{
                                        // display:
                                        //     window.SCOPE_VALUE.CURRENT >
                                        //         window.SCOPE_VALUE.SERVICELINE_ADMIN
                                        //         ? "inline"
                                        //         : "none",
                                        height: "30px",
                                        borderRadius: "4px",
                                        backgroundColor: "#F9F9FB",
                                        width: "13vw",
                                        marginLeft: "10px",
                                        marginRight: "2vw",
                                        marginTop: "1vh"
                                    }}
                                >
                                    {this.state.procedures.map((procedure) => (
                                        <option value={procedure.value}>
                                            {procedure.name}
                                        </option>
                                    ))}
                                </select>

                                <input
                                    type="text"
                                    style={{
                                        width: "10vw",
                                        border: "1px solid #777676",
                                        borderRadius: "3px",
                                        padding: "10px",
                                        height: "0.6vw",
                                        paddingRight: "2rem",
                                    }}
                                    value={this.state.searchTerm}
                                    onChange={this.handleSearch}
                                    placeholder="Search ..."
                                />
                                {this.state.searchTerm && (
                                    <span
                                        onClick={() => this.clearSearchData()}
                                        style={{
                                            // position: "absolute",
                                            right: "8px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer",
                                            color: "#777676",
                                            fontSize: "1.2rem",
                                            fontWeight: "bold",
                                            lineHeight: 1,
                                            userSelect: "none",
                                            marginLeft: "-1vw"
                                        }}
                                    >
                                        ×
                                    </span>
                                )}

                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ marginLeft: '15px', marginTop: '10px' }}>
                        <div className="col-lg-12 ">
                            <div className="card">
                                {this.state.isLoading && (
                                    <div style={{ padding: '20px', textAlign: 'center' }}>
                                        <p>Loading ...</p>
                                    </div>
                                )}
                                {!this.state.isLoading && this.state.data.length === 0 && !this.state.noMatchingData && (
                                    <div style={{ padding: '20px', textAlign: 'center' }}>
                                        <p>There are no medication history present. </p>
                                    </div>
                                )}
                                {(this.state.data.length > 0 && !this.state.noMatchingData) && (
                                    <DataTable
                                        data={this.state.data}
                                        columns={columns}
                                        defaultPageSize={10}
                                        pageSizeOptions={[5, 10, 15]}
                                        pagination={this.state.paginationValue}
                                        onPageChange={this.onPageChange}
                                        page={this.state.pageNum}
                                        noDataComponent={<this.CustomNoDataComponent />}
                                    />)
                                }
                                <div className="graph-container">
                                    {!this.state.isLoading && this.state.medicationGraphData.length > 0 && this.state.medicationGraphData.map((medication, index) => (
                                        <div key={index} className="graph-box">
                                            <h4>{medication.medicationName}</h4>
                                            <Pie data={this.getPieData(medication)} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <ToastContainer className="Toast-at-center" />
                        </div>
                    </div>
                    <div className='card'>
                        {this.state.noMatchingData &&
                            <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                                <p>No matching options found ...</p>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default MedicationResults;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/MedicationResults.js